
// @mui
import { styled } from '@mui/material/styles';
import { Grid, Typography, Stack, Box } from '@mui/material';
// routes

// components
import Logo from '../../components/Logo';
import SocialsButton from '../../components/SocialButtons';
import Image from '../../components/Image'

// ----------------------------------------------------------------------
const socials = {
    facebook: "https://www.facebook.com/",
    twitter: "https://twitter.com/",
    instagram: "https://www.instagram.com/",
    linkedin: "https://www.linkedin.com/company/"
}
const LINKS = [
    {
        headline: 'Contact us On Email:',
        children: [
            { name: 'postapay@posta.co.ke' },
        
        ],
    },
    
    {
        headline: 'Call Us On:',
        children: [
            { name: '0719-072-600 or 0730-642-000.' },
        
        ],
    },
];


const RootStyle = styled('div')(({ theme }) => ({
    position: 'relative',

}));

const currentYear = new Date().getFullYear();




export default function MainFooter() {
    return (
        <RootStyle>
            <Grid
                container
                justifyContent={{ xs: 'center', md: 'space-between' }}
                sx={{ textAlign: { xs: 'center', md: 'left' } }}
            >
                <Grid item xs={12} sx={{ my: 6 }}>
                    <Logo disabledLink={true} isLight={true} sx={{ mx: { xs: 'auto', md: 'inherit' } }} />
                </Grid>
                <Grid item xs={8} md={4}>
                    <Typography variant="body1" sx={{ pr: { md: 5 } }}>
                    Posta pay enables one to send or receive cash in less than five minutes through our wide network of Post Offices.
                    </Typography>

                    <Typography variant='h5' sx={{ mt: 5, pr: { md: 5 } }}>Address</Typography>
                    <Typography variant="body1" sx={{ pr: { md: 5 } }}>
                    Posta House, Kenyatta Avenue Nairobi  <a href='https://google.com'>Kenya</a>
                    </Typography>
                    <Stack 
                        direction="row"
                        justifyContent={{ xs: 'center', md: 'flex-start' }}
                        sx={{ mt: 5, mb: { xs: 5, md: 0 } }}
                    >
                        <SocialsButton links={socials} sx={{ mx: 0.5 }} />
                    </Stack>
                </Grid>

                 <Grid item xs={12} md={4}>
                    <Stack spacing={2} direction={{ xs: 'column', md: 'row' }} justifyContent="space-evenly">
                        {LINKS.map((list) => (
                            <Stack key={list.headline} spacing={2}>
                                <Typography component="p" variant="body1">
                                    {list.headline}
                                </Typography>
                                {list.children.map((link) => (
                                    <Typography
                                        key={link.name}
                                    >
                                        {link.name}
                                    </Typography>
                                ))}
                            </Stack>
                        ))}
                    </Stack>
                </Grid>
            </Grid>
            <Box sx={{ display: 'flex', justifyContent: "center" }} >
                <Typography
                    component="p"
                    variant="body2"
                    sx={{
                        mt: 10,
                        pb: 5,
                        fontSize: 13,
                        textAlign: { xs: 'center', md: 'left' },
                    }}
                >
                    © {currentYear}. PostaPay. All rights reserved
                </Typography>
            </Box>
        </RootStyle>
    );
}
